var exports = {
  "i": "xaee3c4fa--feff1e--wrapper",
};

module.exports = exports;
